import { Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import GlobalButton from '../../utility/globalButton/button';

interface MissingSaveVariableActionValidationPopupProps {
    setFlagValidationWarningInStep: React.Dispatch<React.SetStateAction<boolean>>, 
    listOfInvalidFlowValidationStep: any[],
    flagMissingTemplateActionWarning: boolean,
    setFlagMissingTemplateActionWarning: React.Dispatch<React.SetStateAction<boolean>>,
} 

const MissingSaveVariableActionValidationPopup: React.FC<MissingSaveVariableActionValidationPopupProps> = (props) => {
    
    const { setFlagValidationWarningInStep, listOfInvalidFlowValidationStep, flagMissingTemplateActionWarning, setFlagMissingTemplateActionWarning } = props
    
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>
                                {`Validation Error: ${flagMissingTemplateActionWarning ? 'Missing Template Action' : 'Missing Save Data Action'}`}
                            </Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />  

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Typography sx={{fontSize: "15px !important", fontWeight: "500 !important"}}>
                                        Some nodes in your chatbot are invalid.
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Typography sx={{fontSize: "15px !important", fontWeight: "500 !important"}}>
                                        {`${flagMissingTemplateActionWarning ? 'Some nodes contains a save data action, but does not have a related template action. To publish your chatbot, please update these nodes by adding a Template action.' : 'Some nodes contains a template with a flow button, but does not have a Save Data action to capture the flow output variables. To publish your chatbot, please update these nodes by adding a Save Data action.'}`}
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Typography sx={{fontSize: "15px !important", fontWeight: "500 !important"}}>
                                        <br />The Following steps are Invalid: <br />
                                        <ul>
                                            {listOfInvalidFlowValidationStep?.map((step: any) => {
                                                return (
                                                    <li>
                                                        {step?.chatbot_step_name}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Grid container justifyContent={"center"} sx={{marginTop: "20px"}}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Close"
                                                className='borderedButtonStyle'
                                                sx={{width: "130px"}}
                                                onClick={() => { setFlagValidationWarningInStep(false); setFlagMissingTemplateActionWarning(false)}}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default MissingSaveVariableActionValidationPopup
